/**
 * Progress figures shared by every task page: the "N / total" position of
 * the item on screen and the share of the batch already handled.
 */
export interface TaskPosition {
  /** 1-based, clamped to [1, total]; 0 when the batch is empty. */
  current: number;
  total: number;
}

export function taskPosition(currentIndex: number, total: number): TaskPosition {
  if (total <= 0) return { current: 0, total: 0 };
  return { current: Math.min(Math.max(currentIndex, 0) + 1, total), total };
}

/** Whole percent of `done` over `total`, clamped to 0..100. */
export function taskPercent(done: number, total: number): number {
  if (total <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((done / total) * 100)));
}

export type TaskStepState = "todo" | "current" | "done" | "rejected";

/**
 * One state per item of the batch, for TaskStepDots. `outcome(i)` says what
 * happened to item i; the item on screen is always "current".
 */
export function taskSteps(total: number, currentIndex: number, outcome: (index: number) => "done" | "rejected" | null): TaskStepState[] {
  return Array.from({ length: Math.max(0, total) }, (_, index) => {
    if (index === currentIndex) return "current";
    return outcome(index) ?? "todo";
  });
}
